import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo PNG Transparent/Logo-09.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="w-full border-b border-gray-300 z-50 sticky top-0" style={{ backgroundColor: '#F7F8FA' }}>
      <div className="container-fluid mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" >
            <div className="flex-shrink-0">
              <img src={logo} alt="free" style={{ width: 'auto', margin: '6px auto', height: '40px' }} />
            </div>
          </Link>

          {/* Desktop Navigation - Center */}
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/personality-test"
              className="text-gray-800 hover:text-purple-600 transition-colors duration-200 font-medium"
            >
              Tests
            </Link>
            <Link
              to="/method"
              className="text-gray-800 hover:text-purple-600 transition-colors duration-200 font-medium"
            >
              Method
            </Link>
            <Link
              to="/compass"
              className="text-gray-800 hover:text-purple-600 transition-colors duration-200 font-medium"
            >
              Compass
            </Link>
            <Link
              to="/stories"
              className="text-gray-800 hover:text-purple-600 transition-colors duration-200 font-medium"
            >
              Stories
            </Link>
            <Link
              to="/faq"
              className="text-gray-800 hover:text-purple-600 transition-colors duration-200 font-medium"
            >
              FAQ
            </Link>
            <Link
              to="/pricing"
              className="text-gray-800 hover:text-purple-600 transition-colors duration-200 font-medium"
            >
              Pricing
            </Link>
          </div>

          {/* Get Started Button */}
          <div className="hidden md:block">
            <Link
              to="/essence-echo"
              className="text-white font-medium rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center justify-center"
              style={{ 
                background: 'linear-gradient(90deg, #B967CA 0%, #F1879B 100%)',
                width: '167px',
                height: '48px'
              }}
            >
              Get Started
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-800 hover:text-purple-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-purple-500 transition-colors duration-200"
              aria-expanded="false"
            >
              <span className="sr-only">Open main menu</span>
              {/* Hamburger icon */}
              <svg
                className={`${isMenuOpen ? 'hidden' : 'block'} h-6 w-6`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
              {/* Close icon */}
              <svg
                className={`${isMenuOpen ? 'block' : 'hidden'} h-6 w-6`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        <div className={`${isMenuOpen ? 'block' : 'hidden'} md:hidden`}>
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 border-t border-gray-200" style={{ backgroundColor: '#F7F8FA03' }}>
            <Link
              to="/personality-test"
              className="block px-3 py-2 text-gray-800 hover:text-purple-600 hover:bg-gray-50 rounded-md text-base font-medium transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              Tests
            </Link>
            <Link
              to="/method"
              className="block px-3 py-2 text-gray-800 hover:text-purple-600 hover:bg-gray-50 rounded-md text-base font-medium transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              Method
            </Link>
            <Link
              to="/compass"
              className="block px-3 py-2 text-gray-800 hover:text-purple-600 hover:bg-gray-50 rounded-md text-base font-medium transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              Compass
            </Link>
            <Link
              to="/stories"
              className="block px-3 py-2 text-gray-800 hover:text-purple-600 hover:bg-gray-50 rounded-md text-base font-medium transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              Stories
            </Link>
            <Link
              to="/faq"
              className="block px-3 py-2 text-gray-800 hover:text-purple-600 hover:bg-gray-50 rounded-md text-base font-medium transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              FAQ
            </Link>
            <Link
              to="/pricing"
              className="block px-3 py-2 text-gray-800 hover:text-purple-600 hover:bg-gray-50 rounded-md text-base font-medium transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              Pricing
            </Link>
            <Link
              to="/essence-echo"
              className="text-white rounded-md text-base font-medium hover:shadow-lg transition-all duration-200 flex items-center justify-center mx-auto"
              style={{ 
                background: 'linear-gradient(90deg, #B967CA 0%, #F1879B 100%)',
                width: '167px',
                height: '48px'
              }}
              onClick={() => setIsMenuOpen(false)}
            >
              Get Started
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;